import { combineReducers } from 'redux';
import userInfoReducer from './userInfoReducer';
import appReducer from './appReducer';
import languageReducer from './languageReducer';
import groupReducer from './groupReducer';
import strategyReducer from './strategyReducer';
import chargerReducer from './chargerReducer';
import companyReducer from './companyReducer';
import locationReducer from './locationReducer';
import businessGroupReducer from './businessGroupReducer';
import generalReducer from './generalReducer';

const rootReducer = combineReducers({
    userInfoReducer,
    chargerReducer,
    appReducer,
    languageReducer,
    groupReducer,
    strategyReducer,
    companyReducer,
    locationReducer,
    businessGroupReducer,
    generalReducer,
});

export default rootReducer;
